// Pounding steamed rice into mochi with a mallet. A tap asks for a strike at a
// point: the mallet lifts, swings down onto it, and rebounds. Kneading by hand
// between strikes helps a little. Taps during a
// swing wait their turn (up to three). Each strike makes the rice smoother;
// after enough strikes the rice is mochi.
const RAISE=.28,STRIKE=.12,RECOVER=.3;
export class MochiPounding{
  constructor({strikes=12}={}){this.need=strikes;this.reset();}
  reset(){this.strikes=0;this.queue=[];this.swing=null;this.last=null;this.pose={height:1,lean:0,at:null};this.done=false;}
  // 0 for loose grains, 1 for smooth mochi: quick at first, then finishing touches.
  get smooth(){const t=Math.min(1,this.strikes/this.need);return 1-(1-t)**1.6;}
  request(point){if(this.queue.length<3)this.queue.push([...point]);}
  // Turning and kneading the rice by hand between strikes smooths it a little too
  // (amount in strikes' worth). Returns 'done' once that finishes the mochi.
  knead(amount){
    if(this.done||!(amount>0))return [];
    this.strikes=Math.min(this.need,this.strikes+amount);
    if(this.strikes>=this.need){this.done=true;return [{type:'done'}];}
    return [];
  }
  step(dt){
    const events=[];
    if(!this.swing&&this.queue.length)this.swing={at:this.queue.shift(),t:0,hit:false};
    const s=this.swing;
    if(!s){this.pose={height:1,lean:0,at:this.last??null};return events;}
    s.t+=dt;
    // Height of the mallet head above the strike point: 1 raised to rest, 0 on the rice.
    if(s.t<RAISE){const k=s.t/RAISE;this.pose={height:1+.6*Math.sin(k*Math.PI/2),lean:-.4*k,at:s.at};}
    else if(s.t<RAISE+STRIKE){const k=(s.t-RAISE)/STRIKE;this.pose={height:1.6*(1-k*k),lean:-.4+.4*k,at:s.at};}
    else{
      if(!s.hit){
        s.hit=true;this.strikes++;events.push({type:'hit',at:s.at,smooth:this.smooth});
        if(!this.done&&this.strikes>=this.need){this.done=true;events.push({type:'done'});}
      }
      // It bounces off the rice and comes back up to wait.
      const k=Math.min(1,(s.t-RAISE-STRIKE)/RECOVER);this.pose={height:k+.15*Math.sin(k*Math.PI),lean:0,at:s.at};
      if(k>=1){this.swing=null;this.last=s.at;}
    }
    return events;
  }
}
